module.exports = __webpack_public_path__ + "c30e92e88e72cca9ef7592d3dd55dfc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/amplifyetfs.png
// module id = 1620
// module chunks = 0